import React from 'react';
import { X } from 'lucide-react';
import { useToast } from '../../hooks/useToast';

export default function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col gap-3">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`w-80 max-w-[90vw] rounded-2xl border p-4 shadow-soft bg-card animate-fade-in ${
            toast.variant === 'destructive' ? 'border-destructive' : 'border-border/70'
          }`}
          role="status"
          aria-live="polite"
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="font-display font-semibold">
                {toast.title || (toast.variant === 'destructive' ? 'Hiba történt' : 'Értesítés')}
              </p>
              {toast.description && (
                <p className="text-sm text-muted-foreground mt-1">{toast.description}</p>
              )}
            </div>
            <button
              type="button"
              onClick={() => dismiss(toast.id)}
              className="text-muted-foreground hover:text-foreground"
              aria-label="Értesítés bezárása"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
